const types = {
  ANON_INIT_REQUEST: 'ANON_INIT_REQUEST',
  ANON_INIT_SUCCESS: 'ANON_INIT_SUCCESS',
  ANON_INIT_FAILURE: 'ANON_INIT_FAILURE',
  ADD_REQUEST: 'ADD_REQUEST',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_FAILURE: 'ADD_FAILURE',
  JWT_CANDIDATE_DATA: 'JWT_CANDIDATE_DATA',
  SET_FAKE_MESSAGE: 'SET_FAKE_MESSAGE',
  ADD_FAKE_MESSAGE: 'ADD_FAKE_MESSAGE',
  GET_MESSAGES_REQUEST: 'GET_MESSAGES_REQUEST',
  GET_MESSAGES_SUCCESS: 'GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAILURE: 'GET_MESSAGES_FAILURE',
  SEND_MESSAGE_REQUEST: 'SEND_MESSAGE_REQUEST',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAILURE: 'SEND_MESSAGE_FAILURE',
  ENTER_CHAT: 'ENTER_CHAT',
  SET_IS_ANON: 'SET_IS_ANON',
  SET_IS_CHAT_WIDGET_OPEN: 'SET_IS_CHAT_WIDGET_OPEN',
  REAL_TIME_MSG: 'REAL_TIME_MSG',
  TOGGLE_WIDGET: 'TOGGLE_WIDGET',
  RESET_APP: 'RESET_APP',
  SET_SESSION: 'SET_SESSION',
};

export default types;
